import * as S from './styles.ts';
import ProgressChecklist from '@template/components/ProgressTabs/ProgressChecklist';
import Button from '@template/components/Button';
import { ReactNode } from 'react';

export type TProgressTab = {
  label?: string;
  heading?: string;
  content?: ReactNode;
  key: string | number;
  interactive?: boolean;
  footer?: any;
  simple?: boolean;
  unstyled?: boolean;
};

export interface IProgressTabsProps {
  tabs: TProgressTab[];
  selectedTab: TProgressTab['key'];
  onChange?: (tab: string) => void;
  disabled?: boolean;
}

export const Styles = S;

const ProgressTabs = ({
  tabs = [],
  selectedTab,
  onChange = () => null,
}: IProgressTabsProps) => {
  const tab =
    tabs.find((tab) => tab.key === selectedTab) || (tabs[0] as TProgressTab);

  return (
    <S.ProgressTabsWrapper>
      <S.ProgressTabsContainer>
        <ProgressChecklist steps={tabs} currentStep={selectedTab} />
        <S.ProgressTabWrapper>
          <S.ProgressTabContainer
            key={selectedTab}
            $simple={tab.simple}
            $unstyled={tab.unstyled}
          >
            {tab?.content}
          </S.ProgressTabContainer>
        </S.ProgressTabWrapper>
        {(typeof tab.interactive !== 'boolean' || tab.interactive) && (
          <S.TabNavigationWrapper>
            <S.TabNavigationContainer>
              {tab.footer ? (
                tab.footer
              ) : (
                <>
                  {tabs.findIndex((tab) => tab.key === selectedTab) > 0 && (
                    <Button
                      size='md'
                      variant='outline'
                      onClick={() =>
                        onChange(
                          tabs[
                            tabs.findIndex((tab) => tab.key === selectedTab) - 1
                          ]?.key as any
                        )
                      }
                    >
                      Back
                    </Button>
                  )}
                  {tabs.findIndex((tab) => tab.key === selectedTab) <
                    tabs.length - 1 && (
                    <Button
                      size='md'
                      onClick={() =>
                        onChange(
                          tabs[
                            tabs.findIndex((tab) => tab.key === selectedTab) + 1
                          ]?.key || (tabs[0]?.key as any)
                        )
                      }
                    >
                      Next
                    </Button>
                  )}
                </>
              )}
            </S.TabNavigationContainer>
          </S.TabNavigationWrapper>
        )}
      </S.ProgressTabsContainer>
    </S.ProgressTabsWrapper>
  );
};

export default ProgressTabs;
